var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox"},[_c('div',{staticClass:"checkbox-control"}),_c('div',{staticClass:"checkbox-text"},[_vm._v(_vm._s(_vm.input.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }